import './styles.scss';
import React, { useState } from 'react';
import { Button, Tag } from 'antd';
import { useSelector } from 'react-redux';
import { CombinedState } from 'reducers';

interface OwnProps {
    rawValue: string,
    updateTimelist: (timelist: {start: number, end: number}[]) => void;
}

enum Mode {
    DEFAULT,
    STARTFRAME,
    ENDFRAME
}

function BuildTimeListComponent(props: OwnProps): JSX.Element {
    const [mode, setMode] = useState<Mode>(Mode.DEFAULT);

    const [startFrame, setStartFrame] = useState(0);

    const {rawValue, updateTimelist} = props;
    const frameNumber = useSelector((state: CombinedState): number => state.annotation.player.frame.number);
    const timelist = (rawValue&& JSON.parse(rawValue)) || [];

    return <>
    <>Times:<br/></>
    {
        timelist.map((timeEl: {start: number, end: number}, idx: number)  =>
            <Tag
            key={idx}
            closable
            style={{ userSelect: 'none' }}
            onClose={() => updateTimelist(timelist.slice(0, idx).concat(timelist.slice(idx+1, timelist.length)))}
            >
          {`${timeEl.start}-${timeEl.end}`}
          </Tag>
       )
    }
    <Button onClick={() => {
        if (mode === Mode.DEFAULT) {
            setMode(Mode.STARTFRAME);
        }
        if (mode === Mode.STARTFRAME) {
            setStartFrame(frameNumber)
            setMode(Mode.ENDFRAME);
        }
        if (mode === Mode.ENDFRAME) {
            if (frameNumber > startFrame) {
                updateTimelist(timelist.concat([{
                    start: startFrame,
                    end: frameNumber
                }]))
                setMode(Mode.DEFAULT);
            }

        }
    }} disabled={mode === Mode.ENDFRAME && frameNumber <= startFrame}>
        {mode === Mode.DEFAULT && 'ADD'}
        {mode === Mode.STARTFRAME && 'MARK START'}
        {mode === Mode.ENDFRAME && 'MARK END'}
    </Button>
    </>
}

export default React.memo(BuildTimeListComponent);

